<template>
  <div>
    <div class="main-container">
      <div class="dashboardAdmin-header d-flex align-items-center">
        <img
          src="../../assets/img/feedbackform/backarrow.svg"
          class="pointer"
          @click="goback"
          alt=""
        />
        <div class="dashboardAdmin-header-main-head ml-2">
          <span>View Documents</span>
        </div>
      </div>
      <div
        class="new-reviewdocs-sub-container mt-2"
        :style="$route.query.view && 'height: calc(100vh - 167px) !important;'"
      >
        <div class="d-flex h-100 w-100">
          <div class="w-40 h-100">
            <div class="mt-2 h-100 mb-2">
              <div
                class="
                  d-flex
                  align-items-center
                  justify-content-between
                  pointer
                "
              >
                <div class="newvd-headhing">
                  Candidate has uploaded
                  {{ candidateDetails.documents.length }} documents
                </div>

                <div
                  v-if="candidateDetails.remarks.length !== 0"
                  v-b-modal.viewremarks
                  class="d-flex align-items-center"
                >
                  <img
                    src="../../assets/img/newvendorflow/preview.svg"
                    alt=""
                  />
                  <span class="nvd-remarktxt ml-1">View Remarks</span>
                </div>
              </div>
              <div class="mt-2 h-95 overflow-auto pr-2">
                <div
                  class="pointer position-relative mt-2"
                  v-for="(i, index) in candidateDetails.documents"
                  :key="index"
                  :class="
                    details[index]
                      ? 'docsselectedcard'
                      : 'vrc-uploaddocs-unselectedcard'
                  "
                  @click="firstCard(index)"
                >
                  <div class="new-requireddoc-blueline"></div>
                  <div class="ml-3">{{ i.documentName }}</div>
                </div>
              </div>

              <!-- <div class="mt-2" v-show="candidateDetails.remarks.length > 0">
                <div
                  class="
                    vrc-uploaddocs-unselectedcard
                    position-relative
                    pointer
                  "
                  @click="thirdCard()"
                  :class="thirdocCard == true ? 'docsselectedcard' : ''"
                >
                  <div class="new-requireddoc-blueline"></div>
                  <div class="ml-3">Remarks</div>
                </div>
              </div> -->
            </div>
          </div>
          <div class="w-60 ml-2 new-vd-view-container">
            <div class="new-vd-view-header d-flex align-items-center pl-3">
              {{ candidateDetails.documents[doc].documentName }}
            </div>
            <!-- if aadhar card is selected -->
            <div
              v-if="firstdocCard"
              class="d-flex align-items-center h-90 flex-column"
              style="padding: 5px 80px 5px 80px"
            >
              <div
                class="docslettercontainer h-100 mt-2 mb-2"
                id="scrollToTop"
                style="height: 100%; width: 100%"
              >
                <b-overlay :show="showSpinner" rounded="sm">
                  <div>
                    <pdf
                      ref="pdf"
                      :src="candidateDetails.documents[doc].sources[0]"
                      :page="currentPage"
                      @error="error"
                      @num-pages="numPages = $event"
                      @link-clicked="currentPage = $event"
                      @page-loaded="currentPage = $event"
                    ></pdf>
                  </div>
                </b-overlay>
              </div>

              <div
                v-if="numPages > 1"
                class="newvdpagination canddocslist mt-2"
              >
                <b-pagination
                  v-model="currentPage"
                  @input="scrollFunctionality(), showLoader()"
                  pills
                  :total-rows="numPages"
                  :per-page="perPage"
                  align="center"
                  first-number
                  last-number
                >
                  <template #prev-text>
                    <span>
                      <img
                        src="../../assets/img/newvendorflow/vdleftarw.svg"
                        alt=""
                      />
                    </span>
                  </template>
                  <template #next-text>
                    <span>
                      <img
                        src="../../assets/img/newvendorflow/vdrightarw.svg"
                        alt=""
                      />
                    </span>
                  </template>
                </b-pagination>
              </div>
            </div>

            <!-- if remarks is selected -->
            <!-- <div class="docsinnercontainer" v-if="thirdocCard == true">
              <div class="report-cards-head mt-2">Remarks</div>
              <hr />
              <template v-if="candidateDetails.remarks.length === 0">
                <div>No Remarks Found</div>
              </template>
              <template v-else>
                <div
                  v-for="(i, index) in candidateDetails.remarks"
                  :key="index"
                >
                  <b-row>
                    <div class="ml-5">
                      <img src="../../assets/remarks human.svg" alt="" />
                    </div>
                    <b-col cols="3">
                      <div class="d-flex align-items-center">
                        <span class="ml-1 opsFont">{{ i.recriterName }} </span>
                      </div>
                      <div class="d-flex align-items-center">
                        <div style="width: 50%">
                          <span class="ml-1 statusfont">{{ i.createdAt }}</span>
                        </div>
                      </div>
                    </b-col>
                    <b-col class="mt-1">
                      <div class="d-flex">
                        <span class="statusfont">Status : </span>
                        <span class="rejectedfont ml-1"
                          >Rejected by Recruiter</span
                        >
                      </div>
                      <div class="d-flex">
                        <div class="statusfont">Remarks :</div>
                        <div v-if="i.remark" class="remarksfont ml-1">
                          {{ i.remark }}
                        </div>
                        <div v-else class="remarksfont ml-1">No remarks</div>
                      </div>
                    </b-col>
                  </b-row>
                  <hr />
                </div>
              </template>
            </div> -->
          </div>
        </div>
        <!-- <div
          class="docsfooter d-flex justify-content-between align-items-center"
        >
          <div>
            <img src="../../assets/bluerequired.svg" alt="" />
            <span class="ml-2 docsfont"
              >You can accept or reject documents after verifying
              documents</span
            >
          </div>
          <div class="d-flex">
            <b-button
              class="jdcancelbtn mr-2"
              v-b-modal.acceptmodal
              @click="btn = true"
            >
              <img src="../../assets/reject.svg" alt="" class="mr-2" />
              <span class="rejectfont">Reject</span>
            </b-button>
            <b-button v-b-modal.acceptmodal class="addbtn" @click="btn = false">
              <img src="../../assets/accept.svg" class="p-1 mr-2" alt="" />
              <span class="acceptfont mr-2">Accept</span>
            </b-button>
          </div>
        </div> -->
      </div>
      <div v-if="!$route.query.view" class="new-reviewdocs-footercontainer">
        <div class="d-flex align-items-center justify-content-end w-100">
          <div class="newoutline">
            <b-button
              variant="padding-4-21 outline-primary mr-3"
              v-b-modal.acceptmodal
              @click="btn = true"
              >Reject</b-button
            >
          </div>

          <div class="newprimarybtn">
            <b-button
              v-b-modal.acceptmodal
              class="padding-4-21"
              @click="btn = false"
              >Accept
            </b-button>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="acceptmodal"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      @hidden="closeAcceptModal"
    >
      <div class="d-flex justify-content-between align-items-center">
        <div class="newvd-modal-heading">
          <span v-if="btn == false">Accept Document</span>
          <span v-if="btn == true">Reject Document</span>
        </div>
        <div class="pointer">
          <img
            @click="closeAcceptModal"
            class="rotate-on-hover"
            src="../../assets/img/feedbackform/x-close.svg"
            alt=""
          />
        </div>
      </div>

      <hr />
      <div class="mt-3">
        <span class="newvd-modal-subheading"
          >Are you sure you want to <span v-if="btn == false">accept</span>
          <span v-if="btn == true">reject</span> this candidate's
          <span class="newvd-modal-subheading-cand-name">
            "{{ candidateDetails.name }}"</span
          >
          documents ?
        </span>
      </div>
      <div class="d-flex align-items-center">
        <div class="topDiv mt-3 relativeclass w-100">
          <label class="newvd-modal-label">
            Remarks<span v-if="btn == true" class="asterik">*</span></label
          >
          <b-form-textarea
            style="overflow-y: auto"
            class="remark-box-style"
            placeholder="Enter Remarks"
            rows="3"
            v-model="remark"
            max-rows="6"
            :class="{ error: $v.remark.$error }"
          ></b-form-textarea>
          <div
            v-if="$v.remark.$dirty && !$v.remark.required"
            class="errortxt mt-1"
          >
            Required
          </div>
          <div v-else-if="!$v.remark.maxLength" class="errortxt mt-1">
            Exceeded the max char length of 256
          </div>
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-end mt-5">
        <div class="newoutline">
          <b-button
            variant="padding-4-21 outline-primary mr-3"
            @click="closeAcceptModal"
            >Cancel</b-button
          >
        </div>
        <div class="newprimarybtn">
          <b-button
            class="padding-4-21"
            v-if="btn == false"
            @click="documentStatus(true)"
          >
            Accept
          </b-button>
          <b-button
            class="padding-4-21"
            v-if="btn == true"
            @click="documentStatus(false)"
          >
            Reject
          </b-button>
        </div>
      </div>
    </b-modal>
    <b-modal id="viewremarks" centered hide-footer hide-header @hidden="$bvModal.hide('viewremarks')">
      <div class="p-3 d-flex justify-content-between align-items-center">
        <div class="newvd-modal-heading">View Remarks</div>
        <div class="pointer">
          <img
            @click="$bvModal.hide('viewremarks')"
            class="rotate-on-hover"
            src="../../assets/img/feedbackform/x-close.svg"
            alt=""
          />
        </div>
      </div>

      <hr class="my-2" />
      <div class="p-3">
        <template v-if="candidateDetails.remarks.length === 0">
          <div>No Remarks Found</div>
        </template>
        <template v-else>
          <div
            v-for="(i, index) in candidateDetails.remarks"
            :key="index"
            class="d-flex"
          >
            <div style="width: 15%" class="pt-1">
              <div class="w-5 text-center">
                <div class="roundDarkBlue">
                  {{
                    i.recriterName[0].toUpperCase() +
                    i.recriterName[1].toUpperCase()
                  }}
                  <!-- i.recriterName[0].toUpperCase() +
                      i.recriterName.split(" ")[1][0].toUpperCase() || -->
                  <!-- {{ getImageIcon(i) }} -->
                </div>
              </div>
              <!-- <div class="nvd-remarks-dp"></div> -->
            </div>
            <div style="width: 85%">
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  <div class="nvd-remark-name">{{ i.recriterName }}</div>
                  <div class="nvd-date-txt">{{ i.createdAt }}</div>
                </div>
                <div
                  :style="i.status == 1 || (i.status == 5 && 'color: #038E00')"
                  class="nvd-rejected-txt"
                >
                  {{
                    i.status == null
                      ? ""
                      : i.status == 0 || i.status == 6
                      ? "Rejected"
                      : i.status == 1 || i.status == 5
                      ? "Approved"
                      : ""
                  }}
                </div>
              </div>
              <div class="mt-3 mb-3">
                <div class="nvd-date-txt">Remarks:</div>
                <div v-if="i.remark" class="nvd-remarks-desc">
                  {{ i.remark }}
                </div>
                <div v-else class="nvd-remarks-desc">No remarks</div>
              </div>
            </div>
          </div>
        </template>
        <!-- use hr if there more than one remarks -->
        <!-- <hr class="my-2" /> -->
      </div>
    </b-modal>
  </div>
</template>

<script>
import toast from "../../components/mixin/toast";

import {
  getReviewDocuments,
  postReviewDocuments,
} from "../../utils/apiFunctions.js";
import pdf from "vue-pdf";
import { requiredIf, maxLength } from "vuelidate/lib/validators";

export default {
  name: "viewRequiredCandidateDocs",
  components: {
    pdf,
  },
  data() {
    return {
      firstdocCard: false,
      currentPage: 1,
      numPages: 0,
      perPage: 1,

      seconddocCard: false,
      thirdocCard: false,
      showSpinner: false,

      btn: false,
      doc: null,
      details: [],
      documents: {},
      remark: "",
      reviewDocuments: {},

      accBtn: null,

      candidateDetails: {
        skills: [],
        remarks: [],
      },
    };
  },
  validations: {
    remark: {
      required: requiredIf((obj) => obj.btn),
      maxLength: maxLength(256),
    },
  },
  mixins: [toast],

  created() {
    this.getCandidateDocuments();
  },
  methods: {
    getImageIcon(i) {
      let values = i.split("");
      if (values.length == 2) {
        console.log("yesssssss");
      }

      // console.log(i);
    },
    closeAcceptModal() {
      this.remark = "";
      if (this.btn || !this.btn) {
        this.$bvModal.hide("acceptmodal");
      }
    },
    error: function (err) {
      console.error(err);
    },

    getCandidateDocuments() {
      this.showSpinner = true;
      let payload = {
        jobID: this.$route.query.jobID,
        candidateID: this.$route.query.candidateID,
      };
      getReviewDocuments(payload).then((res) => {
        if (res.status == 200) {
          setTimeout(() => {
            this.showSpinner = false;
          }, 1000);

          this.candidateDetails = res.data.data;
          this.documents = res.data.data.documents;
          for (const j of this.candidateDetails.remarks) {
            j.createdAt = j.createdAt.substring(0, 10);
            // j.imgLogo = this.getImageIcon(j.recruiterName)
          }
          for (let i = 0; i < this.documents.length; i++) {
            this.details[i] = false;
          }
        }
        this.firstCard(0);
      });
    },
    async documentStatus(data) {
      this.$v.remark.$touch();
      if (!this.$v.$invalid) {
        try {
          let payload = {
            jobID: this.$route.query.jobID,
            candidateID: this.$route.query.candidateID,
            isDocumentApproved: data,
            remark: this.remark,
          };
          if (this.$route.query.from == "VendorKanban") {
            payload.vendor = true;
          }
          const res = await postReviewDocuments(payload);
          if (res.status == 200) {
            this.$bvModal.hide("acceptmodal");
            this.goback();
            if (this.btn === false) {
              this.$nextTick(() => {
                this.dynamicToast(
                  "success",
                  `Successfully accepted`,
                  "Documents accepted successfully"
                );
              });
            } else {
              this.$nextTick(() => {
                this.errorModal("Documents rejected");
              });
            }
          } else if (res.status == 409) {
            this.$bvModal.hide("acceptmodal");
            this.dynamicToast(
              "warning",
              `Candidate Already Selected`,
              res.data.data.Detail
            );
          }
        } catch (error) {
          return error;
        }
      }
    },
    goback() {
      if (this.$route.query.from) {
        let params = {};
        let query = {};
        if (this.$route.query.from == "VendorKanban") {
          params.vendorID = query.vendorID = this.$route.query.vendorID;
          params.client = this.$route.query.client;
          query.jobTitle = this.$route.query.jobTitle;
        } else if (this.$route.query.from == "Kanban") {
          query.customerID = this.$route.query.customerID;
        }
        query.jobID = this.$route.query.jobID;
        this.$router.push({
          name: this.$route.query.from,
          query,
          params,
        });
      } else {
        this.$router.go(-1);
      }
    },
    scrollFunctionality() {
      if (document.getElementById("scrollToTop") != null) {
        let element = document.getElementById("scrollToTop");
        element.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
    showLoader() {
      this.showSpinner = true;
      let payload = {
        jobID: this.$route.query.jobID,
        candidateID: this.$route.query.candidateID,
      };
      getReviewDocuments(payload).then((res) => {
        if (res.status == 200) {
          this.showSpinner = false;
        }
      });
    },
    firstCard(i) {
      this.currentPage = 1;
      this.details[i] = !this.details[i];
      if (this.details[i]) {
        for (let j in this.details) {
          if (j != i) {
            this.details[j] = false;
          }
        }
        this.firstdocCard = true;
        this.thirdocCard = false;
        this.seconddocCard = false;
      }

      this.doc = i;
    },
    secondCard() {
      this.seconddocCard = true;
      for (let j in this.details) {
        this.details[j] = false;
      }
      this.firstdocCard = false;
      this.thirdocCard = false;
    },
    thirdCard() {
      for (let j in this.details) {
        this.details[j] = false;
      }
      this.firstdocCard = false;
      this.seconddocCard = false;
      this.thirdocCard = true;
    },
  },
};
</script>
<style>
.canddocslist li {
  padding-top: 5px;
}

.canddocslist .page-link {
  padding: 5px 8px;
}
</style>

<style scoped>
.roundDarkBlue {
  position: relative;
  width: 30px;
  height: 30px;
  background-color: #20639b;
  border: 1px solid white;
  border-radius: 50%;
  font-size: 10px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.canddocslist li {
  display: none;
}

.canddocslist {
  position: relative;
}

.canddocslist ul {
  display: flex;
  justify-content: space-between !important;
}

.canddocslist li:first-child {
  display: block;
  position: absolute;
  top: 40%;
  left: -10px;
  z-index: 65;
}

.canddocslist li:last-child {
  display: block;
  position: absolute;
  top: 40%;
  right: -10px;
  z-index: 65;
}

.badge {
  background: #e8e5e5;
  padding: 5px;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #545454;
}

.candidateDetail {
  padding: 15px;
}

.doclabel {
  font-weight: 400;
  font-size: 12px;
  color: #737373;
}

.docinputField {
  padding: 10px 10px 0px 10px;
  background: #ffffff;
  box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
  border-radius: 5px;
}

.candidadtedetail-scroll {
  height: calc(100vh - 325px);
  overflow: auto;
  overflow-x: hidden;
}

.docCandidateFont {
  font-weight: 400;
  font-size: 14px;
  text-transform: capitalize;

  color: #545454;
}

.rejectedfont {
  color: var(--cv-red);
  font-weight: 800;
  font-size: 14px;
  line-height: 21px;
}

.newDiv {
  padding: 10px;
}

.opsFont {
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #545454;
}

.remarksfont {
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  color: #696969;
}

.statusfont {
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #696969;
}

.notsentfont {
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  color: #3379b3;
}

.pendingfont {
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  color: #fdaa29;
}

.remark-style {
  color: var(--bg-tertiary);
  background: #fdfdfd;
  position: absolute;
  left: 0.5vw;
  top: -9px;

  font-weight: var(--weight-LM);
  font-size: var(--size-12);
  line-height: 18px;

  padding-left: 6px;
  padding-right: 4px;
}

.cancel-text {
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 20px;
  /* identical to box height */

  color: #72738e;
}

li.VuePagination__pagination-item:not(.VuePagination__pagination-item-prev-page):not(.VuePagination__pagination-item-prev-chunk):not(.VuePagination__pagination-item-next-page):not(.VuePagination__pagination-item-next-chunk) {
  display: none;
}

.vrcd-report-cards-head {
  font-weight: 600;
  font-size: 16px;
  color: #4d4d4d;
}

.vrcd-basic-info {
  font-weight: 500;
  font-size: 16px;
  color: #333333;
}

.vrcd-blue-top {
  background: #ddeaff;
  border-radius: 5px 5px 0px 0px;
  padding: 20px 15px;
}

.vrcd-cand-name {
  font-weight: 600;
  font-size: 16px;
  text-transform: capitalize;

  color: #545454;
}

.vrcd-cand-mail {
  font-weight: 500;
  font-size: 14px;
  text-decoration-line: underline;

  color: #545454;
}

.vrcd-cand-phone {
  font-weight: 500;
  font-size: 14px;
  color: #545454;
}
.req-docs-card {
  word-wrap: break-word;
}
.req-accept-card-text {
  color: #8a8b8c;
}
.req-cand-name-text {
  color: #545454;
}

.vrcd-data-not-defined {
  font-weight: 400;
  font-size: 13px;
  text-transform: capitalize;
  color: #c4c4c4;
}
</style>
